// D-1014 (ひろ 2026-10-08 承認): 下から出るシート/モーダルの見出しを 1 つにする。
//   左にタイトル(text-base font-bold)+ 任意で副題(text-xs text-muted)、右に CloseButton(48×48)。
//   ★見出しの行だけを受け持つ。シートの入れ物(背景タップ・スワイプ・focus・高さ)は呼び出し側のまま。
//   ★余白・下線など入れ物に合わせる class は className で渡す。
// D-1117: 任意の action = タイトルと ✕ の間(✕ の左)に置く部品。「?」のヘルプが「不具合・要望」を渡す。
//   ★渡さない呼び出し元(他のシート全部)は DOM を 1 字も変えない(包みの div も出さない)。
//   ★包みは shrink-0。長いタイトルはタイトル側が折り返し、action と ✕ は押せる幅のまま。
import { CloseButton } from './CloseButton'

export function SheetHeader({
  title, subtitle, onClose,
  closeTestId, titleTestId, titleId, closeRef, closeDisabled, closeTone,
  className = '', action = null,
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`.trim()}>
      <div className="flex-1 min-w-0">
        <h2 id={titleId} data-testid={titleTestId} className="text-base font-bold text-text break-words">{title}</h2>
        {subtitle && <p className="text-xs text-muted truncate">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0 flex items-center">{action}</div>}
      <CloseButton
        ref={closeRef}
        onClick={onClose}
        data-testid={closeTestId}
        disabled={closeDisabled}
        tone={closeTone}
        className="-mr-2"
      />
    </div>
  )
}

